<template>
	<div id="app">
		<div class="backdrop" v-if="$store.state.dialog.open"></div>
		<v-dialog
			v-model="$store.state.dialog.open"
			max-width="400">

			<v-card>
				<v-card-title class="headline">{{$store.state.dialog.title}}</v-card-title>

				<v-card-text>{{$store.state.dialog.text}}</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<a @click="$store.state.dialog.open=false" class="fluke-btn fluke-grey">{{$store.state.dialog.cancel}}</a>
					<a @click="$store.state.dialog.open=false" class="fluke-btn">{{$store.state.dialog.confirm}}</a>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<aside v-if="loggedIn">
			<fluke-menu-header />
			<fluke-menu />
		</aside>
		<main v-bind:class="{ active: loggedIn }">
			<fluke-header />
			<fluke-alerts />
			<fluke-content />
			<fluke-footer />
		</main>
	</div>
</template>

<script>
// Menu
import FlukeMenuHeader from './components/Aside/Header/Header.vue';
import FlukeMenu from './components/Aside/Menu/Menu.vue';
// Content
import FlukeHeader from './components/Main/Header/Header.vue';
import FlukeAlerts from './components/Main/Alerts.vue';
import FlukeContent from './components/Main/Content/Content.vue';
import FlukeFooter from './components/Main/Footer/Footer.vue';

export default {
	components: {
		// Menu
		'fluke-menu-header': FlukeMenuHeader,
		'fluke-menu': FlukeMenu,
		// Content
		'fluke-header': FlukeHeader,
		'fluke-alerts': FlukeAlerts,
		'fluke-content': FlukeContent,
		'fluke-footer': FlukeFooter
	},
	updated: function () {
		window.addEventListener('resize', this.resizeHandle)
		this.resizeHandle()
	},
	methods: {
		resizeHandle: function () {
			// const h = document.documentElement.clientHeight - 100
			// document.getElementById('main-content').style.height = h + 'px';
		}
	},
	computed: {
		loggedIn: function () {
			return this.$store.state.loggedIn
		}
	}
}
</script>

<style lang="scss">
.theme--light.v-card {
	background-color: $accent-color !important;
}
.v-dialog__content--active {
	background-color: rgba(0,0,0,.7);
}
.v-time-picker-title__ampm .v-picker__title__btn--active {
	font-weight: 900;
}
.v-date-picker-table .v-btn.v-btn--active {
	color: $accent-color !important;
}
.v-time-picker-clock__item--active {
	font-weight: 900;
	color: #000 !important;

	&:after {
		background-color: #ccc;
	}
}
.v-time-picker-clock__hand.accent {
	background-color: #ccc;
}
.notes {
	padding: 20px;
    border-radius: 10px;
	background-color: #eee;
	margin-bottom: 30px;
}
.error--text {
    color: #ff5252!important;
    caret-color: #ff5252!important;
}
</style>
